module.exports = "../../static/images/default_avator.db9b81.png";